import React from 'react';

const EmptyState = ({ children }) => (
  <div className="q-start">
    <div className="q-start__inner">
      <h1 className="q-start__title">Ask anything about your data.</h1>
      {children}
    </div>
  </div>
);

export default EmptyState;
